import './MunCart.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import HongButtonNew from '../comm/HongButton';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setListCart } from '../reduxToolkit/redux';
import { FaTrash } from "react-icons/fa";

const MunCart = ({onRemoveFromCart, setSelectedItem, selectedItem, setMunSolDap}) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const listCart = useSelector((state) => state.reduxStore.listCart);
  // 개별 해제 함수
  function handleRemove(itemToRemove, index) {
    if (onRemoveFromCart) {
      onRemoveFromCart(itemToRemove, index);
    }
  }

  //=========================================
  return (
    <div className='MunCart'>
      
      <div className='cart-table-wrapper'>
        <div className='cart-table-header'>
          <table>
            <thead>
              <tr>
                <th>{listCart?.length || 0}</th>
                <th>문제</th>
                <th>난이도</th>
                <th>삭제</th>
              </tr>
            </thead>
          </table>
        </div>
        
        <div className='cart-table-body'>
          <table>
            <tbody>
              {listCart && listCart.length > 0 ? (
                listCart.map((item, index) => (
                  <tr key={`cart-${index}`} 
                   className={`${selectedItem && selectedItem.문항번호 === item.문항번호 ? 'selectedRow' : ''}`}
                  onClick={() => { setSelectedItem(item); setMunSolDap('mun'); }}>
                    <td>{index + 1}</td>
                    <td>{item.문항번호}</td>
                    <td>{item.난이도}</td>
                    <td>
                      <HongButtonNew 
                        className="btnReport o-btn-white cart-remove-btn"
                        onClick={(e) => {
                                e.stopPropagation(); 
                                handleRemove(item, index)}
                        }>
                        {/* 제거 */}
                        <FaTrash />
                      </HongButtonNew>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="no-items">
                    선택된 문제가 없습니다.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MunCart;